export default __webpack_public_path__ + "static/media/commentIcon.0229b512.svg";